import Header from '../Header/Header.js';
import Footer from './Footer.js';
import parse from 'html-react-parser';
import { useQuery } from '@apollo/client';
import { GET_GENERAL_SETTING } from '../graphql/Mutation/GeneralSetting.js';
import useScrollToTop from '../components/useScrollToTop.js';


const PrivacyPolicy = () => {
  useScrollToTop();

  const { data } = useQuery(GET_GENERAL_SETTING);
  return (
    <>
      <Header />
      <div className="relative h-[70vh] md:h-[70vh] lg:h-[70vh]">
        <img
          src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/f333.jpg"
          className="w-full h-full object-cover"
          alt="Privacy Policy"
        />
        <p className="font-bold text-white text-2xl sm:text-2xl md:text-2xl absolute bottom-6 left-6 z-30 p-4 bg-black/50 rounded-lg">
          Privacy Policy
        </p>
      </div>

      <div className='mx-auto max-w-auto px-6 py-12 lg:px-8'>
        <div>
          {data?.getGeneralSettings?.prohibitedList ? parse(data?.getGeneralSettings?.prohibitedList) : ''}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
